import { render, staticRenderFns } from "./Equipments.vue?vue&type=template&id=21b50b81&scoped=true"
import script from "./Equipments.vue?vue&type=script&lang=js"
export * from "./Equipments.vue?vue&type=script&lang=js"
import style0 from "./Equipments.vue?vue&type=style&index=0&id=21b50b81&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b50b81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b50b81')) {
      api.createRecord('21b50b81', component.options)
    } else {
      api.reload('21b50b81', component.options)
    }
    module.hot.accept("./Equipments.vue?vue&type=template&id=21b50b81&scoped=true", function () {
      api.rerender('21b50b81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/Equipments.vue"
export default component.exports